import { createStore, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import createDebounce from 'redux-debounced';
import ActivityFeedReducer from '../reducers';

const configureStore = (railsProps) => (
  createStore(ActivityFeedReducer, railsProps, applyMiddleware(createDebounce(), thunk))
);

export default configureStore;
